import axios from "axios";

const baseURL = process.env.REACT_APP_API_BASE_URL;
let headers = {};
if (sessionStorage.token) {
  headers.Authorization = `Bearer ${sessionStorage.token}`;
}

const api = axios.create({
  baseURL: baseURL,
  headers,
});

export default api;
